export default __webpack_public_path__ + "static/vegetables-90657a63526a13c01776cf8eebc6c655.jpg";